import { render, staticRenderFns } from "./TaxReturnLongTermDebtSection.vue?vue&type=template&id=04d160ea&scoped=true&"
import script from "./TaxReturnLongTermDebtSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnLongTermDebtSection.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnLongTermDebtSection.vue?vue&type=style&index=0&id=04d160ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d160ea",
  null
  
)

export default component.exports